export default function Services() {
  const services = [
    {
      title: 'Rückenschmerzen',
      description: 'Starker Rücken, schmerzfreier Alltag. Ich behandle akute und chronische Beschwerden der Wirbelsäule – von Hexenschuss über Bandscheibenvorfälle bis hin zu muskulären Verspannungen. Ziel ist die Wiederherstellung deiner Beweglichkeit und Haltung.',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/2efc11d1-579e-4634-8465-c0842cb4a505_Praxis-83-von-87.jpg?v=1d593dc1c4a5052f3d0a0c1b0c79a7fb',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Gelenkschmerzen',
      description: 'Beweglichkeit erhalten und fördern. Ob Arthrose, Rheuma oder altersbedingter Verschleiß: Ich helfe dir, Schmerzen zu lindern und die Gelenkfunktion sanft zu verbessern, damit Bewegung wieder Freude macht.',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/a1688a01-fd78-48d1-bc59-8d683c5a0701_Gelenkschmerzen.jpg?v=ce13e1b17d862ca9dca3f1f5e8413eaf',
      icon: 'ri-hand-heart-line'
    },
    {
      title: 'Knie- und Schulterschmerzen',
      description: 'Spezialtherapie für komplexe Gelenke. Knie und Schulter sind im Alltag hohen Belastungen ausgesetzt. Ich biete gezielte Mobilisation und Kräftigung nach Verletzungen, Überlastung oder Operationen.',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/543034a6-afc4-455a-8c48-e183a8c79dd9_Praxis-90-von-87.jpg?v=6034b1aa335b4667d2531a9fdb53cf13',
      icon: 'ri-run-line'
    },
    {
      title: 'Inkontinenz',
      description: 'Sicherheit und Lebensqualität durch Beckenbodentraining. Ein sensibles Thema, das ich diskret und professionell behandle. Durch gezieltes Training stärke ich die Beckenbodenmuskulatur bei Blasen- oder Darmschwäche (für Frauen und Männer).',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/89d5e017-d6cf-43cb-8ce3-68f5e32fc296_Pexiball.jpg?v=773affdad34b664a4100022cbe1ea215',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'Kopfschmerzen, Migräne & Tinnitus',
      description: 'Entspannung für Kopf und Nacken. Häufig liegen die Ursachen für Kopfschmerz, Schwindel oder Ohrgeräusche in der Halswirbelsäule oder im Kiefer. Ich löse diese Blockaden und reduziere den Spannungstonus nachhaltig.',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/257e551e-2fb3-4810-ac67-a761d1175c90_Praxis-94-von-87.jpg?v=0748d93ebb239b1300821e7ddc91525e',
      icon: 'ri-brain-line'
    },
    {
      title: 'Atemtherapie',
      description: 'Besser durchatmen. Ich unterstütze Patienten mit chronischen Atemwegserkrankungen (z. B. Asthma, COPD) oder nach Operationen. Erlerne Techniken zur Sekretlösung, Atemerleichterung und Entspannung.',
      image: 'https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/363f5d36-3bb5-4d48-854e-b16d06236c60_Praxis-92-von-87.jpg?v=90fff2ad62f1ffad73b1c6a7b40a7b8d',
      icon: 'ri-lungs-line'
    }
  ];

  return (
    <section id="leistungen" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-gold-500 text-sm font-medium tracking-[0.2em] uppercase mb-4 block">
            Behandlungen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mb-4 text-olive-900">
            Alles, was du brauchst
          </h2>
          <div className="w-16 h-px bg-gold-300 mx-auto mb-6"></div>
          <p className="text-lg text-olive-700 max-w-3xl mx-auto font-light">
            Umfassende physiotherapeutische Behandlungen, individuell auf deine Bedürfnisse abgestimmt
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-sm border border-olive-100 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-olive-900/30 via-olive-900/5 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-14 h-14 bg-gradient-to-br from-gold-200 to-gold-300 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-2xl text-olive-900`}></i>
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-xl font-semibold mb-3 text-olive-900">{service.title}</h3>
                <p className="text-olive-600 leading-relaxed text-sm font-light">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
